import { MarketingHeader } from "./MarketingHeader";
import { useMobileMenu } from "@shared/features/mobileMenu/useMobileMenu";

export type Props = {
  // navigation items component
  children: React.ReactNode;
};

export function MarketingHeaderContainer({ children }: Props) {
  const { isMobileMenuOpen, openMobileMenu, closeMobileMenu } = useMobileMenu();

  return (
    <MarketingHeader
      isMobileMenuOpen={isMobileMenuOpen ?? false}
      openMobileMenu={openMobileMenu}
      closeMobileMenu={closeMobileMenu}
    >
      {children}
    </MarketingHeader>
  );
}

export default MarketingHeaderContainer;
